<template lang="pug">
section.rewards
  .content
    RewardsGroup(
      v-for="(rewards_list, rewards_type) in rewards",
      :key="rewards_type",
      :rewardsList="rewards_list",
      :type="rewards_type"
    )
</template>

<script>
import RewardsGroup from "./RewardsGroup";

export default {
  name: "Rewards",
  components: {
    RewardsGroup,
  },
  data() {
    return {
      rewards: {
        gold: ["statue-1", "scroll-1", "knight-1"],
        silver: ["statue-2", "scroll-2", "knight-2"],
        bronze: ["statue-3", "scroll-3", "knight-3"],
      },
    }
  },
};
</script>
